<template>
  <div class="title">{{ title }}</div>
</template>

<script>
export default {
  name: "chart-title",
  props: {
    words: Array,
    separator: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
      title: "",
    };
  },
  mounted() {
    this.to_title();
  },
  watch: {
    words() {
      this.to_title();
    },
  },
  methods: {
    to_title() {
      this.title = '';
      let _this = this;
      let arr = this.words.filter(i=>i)
      arr.forEach((value,index) =>
        value !== "" ? ((_this.title !== '' && index > 1)? _this.title += _this.separator + value : _this.title += value) : 0
      );
    },
  },
};
</script>